import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import MockupMacBook from "../../assets/images/Macbook-Air.png";

const HomeSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section
      id="home-section"
      className="min-h-screen flex items-center justify-center py-20 overflow-hidden"
      style={{
        background:
          "linear-gradient(180deg, rgba(254, 182, 146, 0.35) 0%, rgba(234, 84, 85, 0.35) 100%)",
      }}
    >
      <div className="container mx-auto flex flex-col md:flex-row items-start px-6 md:px-20">
        {/* Bagian Kiri */}
        <div className="md:w-1/2 text-left md:mr-20" data-aos="fade-up">
          <h1 className="text-[36px] pt-5 font-semibold leading-tight text-[#E98362]">
            Apa itu Wedify?
          </h1>
          <p className="text-[16px] font-medium text-[#49516F] mt-4 text-justify pr-6">
            Wedify adalah platform undangan pernikahan digital yang simpel dan
            praktis. Buat, sesuaikan, dan bagikan undangan dengan mudah dalam
            hitungan menit. Tanpa cetak, tanpa ribet—lebih cepat, lebih hemat,
            dan elegan.
          </p>

          {/* Slogan */}
          <div className="mt-6">
            <p className="text-[24px] font-normal text-[#E98362]">
              Your Dream Wedding
            </p>
            <p className="text-[24px] font-bold text-[#E98362]">
              STARTS WITH A CLICK!
            </p>
          </div>

          <button
            className="mt-6 px-3 py-2 bg-[#F59581] text-white text-[14px] font-semibold rounded-lg shadow-md hover:bg-[#e57a67] transition"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            Buat Undanganmu Sekarang!
          </button>
        </div>

        {/* Bagian Kanan */}
        <div
          className="md:w-1/2 flex justify-center mt-10 md:mt-0"
          data-aos="zoom-in"
        >
          <img
            src={MockupMacBook}
            alt="Mockup MacBook"
            className="w-full max-w-xl"
          />
        </div>
      </div>
    </section>
  );
};

export default HomeSection;
